<template>
  <section v-on:click="sectionClicked">
    <div class="preview" v-if="page && page.type === 'Content'
      && ['draft', 'upcoming', 'unpublished'].includes(page.content.status)">
      This is a preview, go to admin panel to publish this content</div>
    <div class="notFoundCnt" v-if="!page || !page.content">
      <div class="notFound">
        <img src="../assets/not-found.png">
        <h4>404</h4>
        <h2>Halaman tidak ditemukan</h2>
        <p>We can't find the page you looking for</p>
        <button v-on:click="$router.push('/')">Back To Home</button>
      </div>
    </div>
    <div class="articleDetailCnt article" v-else-if="page.content.type === 'article'">
      <div class="articleDetail ad1">
        <div class="content">
          <div class="label" v-if="page.content.tags && page.content.tags.length > 0">
            <a :href="`/bri-guide/${page.content.parent.code}?q=${escape(tag)}`"
              class="labelItem" v-for="(tag, i) in page.content.tags"
              :key="`dt${i}`">{{tag}}</a>
          </div>
          <h2 class="articleTitle">{{page.content.title[lang]}}</h2>
          <div class="authorInfo" v-if="page.content.displayAuthor
            || page.content.displayPublishDate || page.content.displayViews"
            :class="{noAuthor: !page.content.displayAuthor}">
            <div class="authorImg"></div>
            <h4 v-if="page.content.author && page.content.displayAuthor">
              {{page.content.author.name}}</h4>
            <div class="publishTime"
              v-if="page.content.displayPublishDate || page.content.displayViews">
              <span class="timestamp" v-if="page.content.publishDate
                && page.content.displayPublishDate">
                {{page.content.publishDate | moment(page.content.dateFormat)}}
              </span>
              <span class="timestamp" v-if="page.content.displayViews">
                <span class="bull" v-if="page.content.displayPublishDate">&bull;</span>
                <template v-if="page.content.viewCount > 1">
                  <template v-if="page.content.viewCount >= 1000000000">
                    {{Math.floor(page.content.viewCount/1000000000).toLocaleString('id')}}b
                  </template>
                  <template v-else-if="page.content.viewCount >= 1000000">
                    {{Math.floor(page.content.viewCount/1000000).toLocaleString('id')}}m
                  </template>
                  <template v-if="page.content.viewCount >= 1000">
                    {{Math.floor(page.content.viewCount/1000).toLocaleString('id')}}k
                  </template>
                  <template v-else-if="page.content.viewCount">
                    {{page.content.viewCount.toLocaleString('id')}}
                  </template>
                  views
                </template>
                <template v-else>{{page.content.viewCount || 0}} view</template>
              </span>
              <span class="bull">&bull;</span>
              <span class="reading-time__label"></span>
              <span class="reading-time_duration"></span>
              <span class="reading-time__duration"></span>
              <span class="reading-time__word-count"></span>
            </div>
          </div>
          <div class="articleShare articleShareStatic" v-if="page.content.displayShare">
            <h4 v-if="lang === 'id'">Bagikan</h4>
            <h4 v-if="lang === 'en'">Share</h4>
            <div class="shareCnt">
              <a target="_blank"
                :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                <i class="fa fa-facebook fa-fw"></i>
              </a>
              <a target="_blank"
                :href="`https://twitter.com/intent/tweet?text=${page.content.title}&amp;url=${shareUri}`">
                <i class="fa fa-twitter fa-fw"></i>
              </a>
              <a :href="`whatsapp://send?text=${page.content.title} ${shareUri}`">
                <i class="fa fa-whatsapp fa-fw"></i>
              </a>
              <a target="_blank"
                :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${page.content.title}`">
                <i class="fa fa-telegram fa-fw"></i>
              </a>
              <a :href="`mailto:?subject=${page.content.title}&amp;body=Check this out:
                <a href='${shareUri}'>${page.content.title}</a>`">
                <i class="fa fa-email fa-fw"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <template v-if="page.content.useHeaderImg === 1">
        <div class="articleHeaderImg" v-if="page.content.thumbHd && page.content.thumbHd[lang]"
          :style="{'background-image': `url(${page.content.thumbHd[lang]})`}"
          :class="[page.content.coverStyle, {protected: page.content.isProtected}]">
          <img :src="page.content.thumbHd[lang]" v-if="page.content.coverStyle === 'full'"
            v-on:load="changeBaseShareTop">
          <div class="protectedContent" v-if="page.content.isProtected">
            <div class="protectedContentIn">
              <img src="../assets/padlock-white.png">
              <h4 v-if="lang === 'en'">Locked Content</h4>
              <h4 v-if="lang === 'id'">Konten Terkunci</h4>
            </div>
          </div>
        </div>
        <div class="articleHeaderImg noImg" v-else
          :class="{protected: page.content.isProtected}">
          <div class="protectedContent" v-if="page.content.isProtected">
            <div class="protectedContentIn">
              <img src="../assets/padlock-white.png">
              <h4 v-if="lang === 'en'">Locked Content</h4>
              <h4 v-if="lang === 'id'">Konten Terkunci</h4>
            </div>
          </div>
        </div>
      </template>
      <div class="articleDetail ad2">
        <div class="content">
          <div ref="contentHelper" class="contentHelper"></div>
          <div class="pPos" :style="{left: `${pPos.x}px`, top: `${pPos.y}px`}"
            :class="{open: pPos.show}">
            <li v-on:click.stop="tweet">
              <img src="../assets/twitter-white.png"> Tweet</li>
            <li v-on:click.stop="comment" v-if="1>2">
              <img src="../assets/chat-white.png"> Comment</li>
          </div>
          <div class="protectedContent" v-if="page.content.isProtected">
            <div class="protectedContentIn">
              <img src="../assets/padlock.png">
              <h4>
                <template v-if="lang === 'id'">Konten Terkunci</template>
                <template v-if="lang === 'en'">Locked Content</template>
              </h4>
              <p v-if="page.content.hasPassword">
                <template v-if="lang === 'id'">
                  Mohon masukan password untuk membuka konten ini
                </template>
                <template v-if="lang === 'en'">
                  Please input password to unlock this content
                </template>
              </p>
              <p v-else>
                <template v-if="lang === 'id'">
                  Kamu tidak mempunyai hak akses untuk membuka konten ini
                </template>
                <template v-if="lang === 'en'">
                  You dont have right to access this content
                </template>
              </p>
              <form v-if="page.content.hasPassword"
                v-on:submit.prevent="unlockContent">
                <div class="fieldGroup" :class="{hasError: form.password.error}">
                  <input type="password" placeholder="Password..." class="field"
                    v-model="form.password.model" :disabled="passwordLoading"
                    v-on:input="form.password.error = null" ref="password">
                  <button type="submit" class="btn primary"
                    :class="{loading: passwordLoading}">
                    <span>Unlock</span>
                  </button>
                  <div class="fieldError" v-if="form.password.error">
                    {{form.password.error}}
                  </div>
                </div>
              </form>
            </div>
          </div>
          <article class="articleContent detail-wrapper"
            :data-comment="true" v-else
            v-html="page.content.content[lang]"></article>
          <Attachment :attachments="page.content.attachments[lang]"
            v-if="page.content.attachments[lang]
            && page.content.attachments[lang].length > 0"></Attachment>
        </div>

        <div class="articleShare" :style="{top: `${shareTop}px`}"
          v-if="showShare && page.content.displayShare">
          <h4 v-if="lang === 'id'">Bagikan</h4>
          <h4 v-if="lang === 'en'">Share</h4>
          <div class="shareCnt">
            <a target="_blank"
              :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
              <i class="fa fa-facebook fa-fw"></i>
            </a>
            <a target="_blank"
              :href="`https://twitter.com/intent/tweet?text=${page.content.title[lang]}&amp;url=${shareUri}`">
              <i class="fa fa-twitter fa-fw"></i>
            </a>
            <a :href="`whatsapp://send?text=${page.content.title[lang]} ${shareUri}`">
              <i class="fa fa-whatsapp fa-fw"></i>
            </a>
            <a target="_blank"
              :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${page.content.title[lang]}`">
              <i class="fa fa-telegram fa-fw"></i>
            </a>
            <a :href="`mailto:?subject=${page.content.title[lang]}&amp;body=Check this out:
              <a href='${shareUri}'>${page.content.title[lang]}</a>`">
              <i class="fa fa-email fa-fw"></i>
            </a>
          </div>
        </div>
        <div ref="endArticle"/>
        <div class="articleBottom" v-if="(page.content.tags[lang]
          && page.content.tags[lang].length > 0)
          || page.content.displayShare">
          <div class="articleBottomCnt">
            <div class="tags" v-if="page.content.tags[lang] && page.content.tags[lang].length > 0">
              <a href="#" class="tagItem btn"
                v-for="(tag, i) in page.content.tags[lang]" :key="`tag${i}`">
                #{{tag}}
              </a>
            </div>
            <div class="articleShare articleShareStatic articleShareBottom"
              v-if="page.content.displayShare">
              <h4 v-if="lang === 'id'">Bagikan</h4>
              <h4 v-if="lang === 'en'">Share</h4>
              <div class="shareCnt">
                <a target="_blank"
                  :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                  <i class="fa fa-facebook fa-fw"></i>
                </a>
                <a target="_blank"
                  :href="`https://twitter.com/intent/tweet?text=${page.content.title}&amp;url=${shareUri}`">
                  <i class="fa fa-twitter fa-fw"></i>
                </a>
                <a :href="`whatsapp://send?text=${page.content.title} ${shareUri}`">
                  <i class="fa fa-whatsapp fa-fw"></i>
                </a>
                <a target="_blank"
                  :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${page.content.title}`">
                  <i class="fa fa-telegram fa-fw"></i>
                </a>
                <a :href="`mailto:?subject=${page.content.title}&amp;body=Check this out:
                  <a href='${shareUri}'>${page.content.title}</a>`">
                  <i class="fa fa-email fa-fw"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="relatedWrapper" v-if="related && related.length > 0">
          <h4 class="relatedTitle">Related contents</h4>
          <div class="relatedSc">
            <div class="relatedCnt">
              <div class="relatedItem" v-for="(item, i) in related" :key="`r${i}`"
                :class="[`rt${i}`]">
                <a :href="`/bri-guide/page/${item.parent.code}/detail/${item.code}`">
                  <div class="relatedImg theImg" :style="{'background-image': `url(${item.thumb})`}"
                    v-if="item.thumb"></div>
                  <div class="relatedImg theImg noImg" v-else></div>
                </a>
                <a :href="`/bri-guide/page/${item.parent.code}/detail/${item.code}`">
                  <h4>{{item.title}}</h4>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="readTimePrc" :class="{hidden: scrollPrc >= 100}">
        <div role="progressbar" aria-valuenow="65" aria-valuemin="0"
          aria-valuemax="100" :style="{'--value': scrollPrc}"></div>
      </div>
    </div>
    <div class="articleDetailCnt event" v-else-if="page.content.type === 'event'">
      <div class="eventCnt">
        <template v-if="page.content.useHeaderImg">
          <div class="eventHeader" v-if="page.content.headerImg && page.content.headerImg[lang]"
            :style="{'background-image': `url(${page.content.headerImg[lang].imageLg})`}"
            :class="[page.content.coverStyle, {protected: page.content.isProtected}]">
            <img :src="page.content.headerImg[lang].imageLg"
              v-if="page.content.coverStyle === 'full'">
            <div class="protectedContent" v-if="page.content.isProtected">
              <div class="protectedContentIn">
                <img src="../assets/padlock-white.png">
                <h4 v-if="lang === 'en'">Locked Content</h4>
                <h4 v-if="lang === 'id'">Konten Terkunci</h4>
              </div>
            </div>
          </div>
          <div class="eventHeader noImg" v-else
            :class="{protected: page.content.isProtected}">
            <div class="protectedContent" v-if="page.content.isProtected">
              <div class="protectedContentIn">
                <img src="../assets/padlock-white.png">
                <h4 v-if="lang === 'en'">Locked Content</h4>
                <h4 v-if="lang === 'id'">Konten Terkunci</h4>
              </div>
            </div>
          </div>
        </template>
        <div class="eventInfo">
          <h4>{{page.content.title[lang]}}</h4>
          <div class="authorInfo" v-if="page.content.displayAuthor
            || page.content.displayPublishDate || page.content.displayViews"
            :class="{noAuthor: !page.content.displayAuthor}">
            <div class="authorImg"></div>
            <h4 v-if="page.content.author && page.content.displayAuthor">
              {{page.content.author.name}}</h4>
            <div class="publishTime"
              v-if="page.content.displayPublishDate || page.content.displayViews">
              <span class="timestamp" v-if="page.content.publishDate
                && page.content.displayPublishDate">
                {{page.content.publishDate | moment(page.content.dateFormat)}}
              </span>
              <span class="timestamp" v-if="page.content.displayViews">
                <span class="bull" v-if="page.content.displayPublishDate">&bull;</span>
                <template v-if="page.content.viewCount > 1">
                  <template v-if="page.content.viewCount >= 1000000000">
                    {{Math.floor(page.content.viewCount/1000000000).toLocaleString('id')}}b
                  </template>
                  <template v-else-if="page.content.viewCount >= 1000000">
                    {{Math.floor(page.content.viewCount/1000000).toLocaleString('id')}}m
                  </template>
                  <template v-if="page.content.viewCount >= 1000">
                    {{Math.floor(page.content.viewCount/1000).toLocaleString('id')}}k
                  </template>
                  <template v-else-if="page.content.viewCount">
                    {{page.content.viewCount.toLocaleString('id')}}
                  </template>
                  views
                </template>
                <template v-else>{{page.content.viewCount || 0}} view</template>
              </span>
            </div>
          </div>
          <div class="protectedContent" v-if="page.content.isProtected">
            <div class="protectedContentIn">
              <img src="../assets/padlock.png">
              <h4>
                <template v-if="lang === 'id'">Konten Terkunci</template>
                <template v-if="lang === 'en'">Locked Content</template>
              </h4>
              <p v-if="page.content.hasPassword">
                <template v-if="lang === 'id'">
                  Mohon masukan password untuk membuka konten ini
                </template>
                <template v-if="lang === 'en'">
                  Please input password to unlock this content
                </template>
              </p>
              <p v-else>
                <template v-if="lang === 'id'">
                  Kamu tidak mempunyai hak akses untuk membuka konten ini
                </template>
                <template v-if="lang === 'en'">
                  You dont have right to access this content
                </template>
              </p>
              <form v-if="page.content.hasPassword"
                v-on:submit.prevent="unlockContent">
                <div class="fieldGroup" :class="{hasError: form.password.error}">
                  <input type="password" placeholder="Password..." class="field"
                    v-model="form.password.model" :disabled="passwordLoading"
                    v-on:input="form.password.error = null" ref="password">
                  <button type="submit" class="btn primary"
                    :class="{loading: passwordLoading}">
                    <span>Unlock</span>
                  </button>
                  <div class="fieldError" v-if="form.password.error">
                    {{form.password.error}}
                  </div>
                </div>
              </form>
            </div>
          </div>
          <a :href="page.content.linkUrl" target="_blank"
            class="btn primary eventBtn" v-if="page.content.linkUrl">
            <span v-if="lang === 'id'">Ikuti Acara</span>
            <span v-if="lang === 'en'">Join Event</span>
          </a>
          <div class="infoItem" v-if="page.content.eventDate">
            <div class="infoLabel">Tanggal Mulai</div>
            <div class="infoValue">{{page.content.eventDate
              | moment('D MMMM YYYY HH:mm')}}</div>
          </div>
          <div class="infoItem" v-if="page.content.eventDate
            && page.content.eventDate2">
            <div class="infoLabel">Durasi</div>
            <div class="infoValue">
              {{page.content.eventDate | moment(page.content.timeFormat)}}
              -
              {{page.content.eventDate2 | moment(page.content.timeFormat)}}
              WIB
            </div>
          </div>
          <div class="infoItem" :key="`meta${i}`"
            v-for="(meta, i) in page.content.metadata">
            <div class="infoLabel">{{meta.label[lang]}}</div>
            <div class="infoValue" v-if="meta.value[lang]">{{meta.value[lang]}}</div>
            <div class="infoValue" v-else>-</div>
          </div>
          <div class="infoContent" v-if="page.content.description
            && page.content.content[lang]"
            v-html="page.content.content[lang]"></div>
          <Attachment :attachments="page.content.attachments[lang]"
            v-if="page.content.attachments[lang]
            && page.content.attachments[lang].length > 0"></Attachment>
        </div>
      </div>
      <div class="articleShare articleShareStatic articleShareBottom"
        v-if="page.content.displayShare">
        <h4 v-if="lang === 'id'">Bagikan</h4>
        <h4 v-if="lang === 'en'">Share</h4>
        <div class="shareCnt">
          <a target="_blank"
            :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
            <i class="fa fa-facebook fa-fw"></i>
          </a>
          <a target="_blank"
            :href="`https://twitter.com/intent/tweet?text=${page.content.title}&amp;url=${shareUri}`">
            <i class="fa fa-twitter fa-fw"></i>
          </a>
          <a :href="`whatsapp://send?text=${page.content.title} ${shareUri}`">
            <i class="fa fa-whatsapp fa-fw"></i>
          </a>
          <a target="_blank"
            :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${page.content.title}`">
            <i class="fa fa-telegram fa-fw"></i>
          </a>
          <a :href="`mailto:?subject=${page.content.title}&amp;body=Check this out:
            <a href='${shareUri}'>${page.content.title}</a>`">
            <i class="fa fa-email fa-fw"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="articleDetailCnt profile" v-else-if="page.content.type === 'profile'">
      <div class="cnt profileCnt">
        <div class="profileImgCnt">
          <div class="profileImg" v-if="page.content.thumbHd && page.content.thumbHd[lang]"
            :style="{'background-image': `url(${page.content.thumbHd[lang]})`}"
            :class="[page.content.coverStyle, {protected: page.content.isProtected}]">
            <img :src="page.content.thumbHd[lang]" v-if="page.content.coverStyle === 'full'">
            <div class="protectedContent" v-if="page.content.isProtected">
              <div class="protectedContentIn">
                <img src="../assets/padlock-white.png">
                <h4 v-if="lang === 'en'">Locked Content</h4>
                <h4 v-if="lang === 'id'">Konten Terkunci</h4>
              </div>
            </div>
          </div>
          <div class="profileImg noImg" v-else
            :class="{protected: page.content.isProtected}">
            <div class="protectedContent" v-if="page.content.isProtected">
              <div class="protectedContentIn">
                <img src="../assets/padlock-white.png">
                <h4 v-if="lang === 'en'">Locked Content</h4>
                <h4 v-if="lang === 'id'">Konten Terkunci</h4>
              </div>
            </div>
          </div>
          <div class="profileMetadata">
            <a :href="page.content.googleScholerUri[lang]"
              target="_blank" class="metadataItem googleScholar"
              v-if="page.content.googleScholerUri
              && page.content.googleScholerUri[lang]"></a>
            <a :href="`mailto:${page.content.email[lang]}`"
              target="_blank" class="metadataItem email"
              v-if="page.content.email && page.content.email[lang]"></a>
            <a :href="page.content.linkedIn[lang]"
              target="_blank" class="metadataItem linkedIn"
              v-if="page.content.linkedIn && page.content.linkedIn[lang]"></a>
            <a :href="page.content.youtube[lang]"
              target="_blank" class="metadataItem youtube"
              v-if="page.content.youtube && page.content.youtube[lang]"></a>
            <a :href="page.content.twitter[lang]" target="_blank"
              class="metadataItem twitter"
              v-if="page.content.twitter && page.content.twitter[lang]"></a>
            <a :href="page.content.facebook[lang]" target="_blank"
              class="metadataItem facebook"
              v-if="page.content.facebook && page.content.facebook[lang]"></a>
            <a :href="page.content.instagram[lang]" target="_blank"
              class="metadataItem instagram"
              v-if="page.content.instagram && page.content.instagram[lang]"></a>
            <a :href="page.content.spotify[lang]" target="_blank"
              class="metadataItem spotify"
              v-if="page.content.spotify && page.content.spotify[lang]"></a>
            <a :href="page.content.tiktok[lang]" target="_blank"
              class="metadataItem tiktok"
              v-if="page.content.tiktok && page.content.tiktok[lang]"></a>
            <a :href="page.content.web[lang]" target="_blank"
              class="metadataItem web"
              v-if="page.content.web && page.content.web[lang]"></a>
          </div>
        </div>
        <div class="profileInfo">
          <h4>{{page.content.title[lang]}}</h4>
          <div class="position" v-if="page.content.position
            && page.content.position[lang] && !page.content.isProtected">
            {{page.content.position[lang]}}</div>
          <div class="authorInfo" v-if="page.content.displayAuthor
            || page.content.displayPublishDate || page.content.displayViews"
            :class="{noAuthor: !page.content.displayAuthor}">
            <div class="authorImg"></div>
            <h4 v-if="page.content.author && page.content.displayAuthor">
              {{page.content.author.name}}</h4>
            <div class="publishTime"
              v-if="page.content.displayPublishDate || page.content.displayViews">
              <span class="timestamp" v-if="page.content.publishDate
                && page.content.displayPublishDate">
                {{page.content.publishDate | moment(page.content.dateFormat)}}
              </span>
              <span class="timestamp" v-if="page.content.displayViews">
                <span class="bull" v-if="page.content.displayPublishDate">&bull;</span>
                <template v-if="page.content.viewCount > 1">
                  <template v-if="page.content.viewCount >= 1000000000">
                    {{Math.floor(page.content.viewCount/1000000000).toLocaleString('id')}}b
                  </template>
                  <template v-else-if="page.content.viewCount >= 1000000">
                    {{Math.floor(page.content.viewCount/1000000).toLocaleString('id')}}m
                  </template>
                  <template v-if="page.content.viewCount >= 1000">
                    {{Math.floor(page.content.viewCount/1000).toLocaleString('id')}}k
                  </template>
                  <template v-else-if="page.content.viewCount">
                    {{page.content.viewCount.toLocaleString('id')}}
                  </template>
                  views
                </template>
                <template v-else>{{page.content.viewCount || 0}} view</template>
              </span>
            </div>
          </div>
          <div class="articleDetail ad2">
            <div class="protectedContent" v-if="page.content.isProtected">
              <div class="protectedContentIn">
                <img src="../assets/padlock.png">
                <h4>
                  <template v-if="lang === 'id'">Konten Terkunci</template>
                  <template v-if="lang === 'en'">Locked Content</template>
                </h4>
                <p v-if="page.content.hasPassword">
                  <template v-if="lang === 'id'">
                    Mohon masukan password untuk membuka konten ini
                  </template>
                  <template v-if="lang === 'en'">
                    Please input password to unlock this content
                  </template>
                </p>
                <p v-else>
                  <template v-if="lang === 'id'">
                    Kamu tidak mempunyai hak akses untuk membuka konten ini
                  </template>
                  <template v-if="lang === 'en'">
                    You dont have right to access this content
                  </template>
                </p>
                <form v-if="page.content.hasPassword"
                  v-on:submit.prevent="unlockContent">
                  <div class="fieldGroup" :class="{hasError: form.password.error}">
                    <input type="password" placeholder="Password..." class="field"
                      v-model="form.password.model" :disabled="passwordLoading"
                      v-on:input="form.password.error = null" ref="password">
                    <button type="submit" class="btn primary"
                      :class="{loading: passwordLoading}">
                      <span>Unlock</span>
                    </button>
                    <div class="fieldError" v-if="form.password.error">
                      {{form.password.error}}
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="content" v-else>
              <article class="articleContent detail-wrapper"
                :data-comment="true"
                v-html="page.content.content[lang]"></article>
              <Attachment :attachments="page.content.attachments[lang]"
                v-if="page.content.attachments[lang]
                && page.content.attachments[lang].length > 0"></Attachment>
            </div>
            <div class="articleShare" :style="{top: `${shareTop}px`}"
              v-if="showShare && page.content.displayShare">
              <h4 v-if="lang === 'id'">Bagikan</h4>
              <h4 v-if="lang === 'en'">Share</h4>
              <div class="shareCnt">
                <a target="_blank"
                  :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
                  <i class="fa fa-facebook fa-fw"></i>
                </a>
                <a target="_blank"
                  :href="`https://twitter.com/intent/tweet?text=${page.content.title[lang]}&amp;url=${shareUri}`">
                  <i class="fa fa-twitter fa-fw"></i>
                </a>
                <a :href="`whatsapp://send?text=${page.content.title[lang]} ${shareUri}`">
                  <i class="fa fa-whatsapp fa-fw"></i>
                </a>
                <a target="_blank"
                  :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${page.content.title[lang]}`">
                  <i class="fa fa-telegram fa-fw"></i>
                </a>
                <a :href="`mailto:?subject=${page.content.title[lang]}&amp;body=Check this out:
                  <a href='${shareUri}'>${page.content.title[lang]}</a>`">
                  <i class="fa fa-email fa-fw"></i>
                </a>
              </div>
            </div>
            <div ref="endArticle"/>
            <div class="relatedWrapper" v-if="related && related.length > 0">
              <h4 class="relatedTitle">Related contents</h4>
              <div class="relatedSc">
                <div class="relatedCnt">
                  <div class="relatedItem" v-for="(item, i) in related" :key="`r${i}`"
                    :class="[`rt${i}`]">
                    <a :href="`/bri-guide/page/${item.parent.code}/detail/${item.code}`">
                      <div class="relatedImg theImg" :style="{'background-image': `url(${item.thumb})`}"
                        v-if="item.thumb"></div>
                      <div class="relatedImg theImg noImg" v-else></div>
                    </a>
                    <a :href="`/bri-guide/page/${item.parent.code}/detail/${item.code}`">
                      <h4>{{item.title}}</h4>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="articleDetailCnt media" v-else-if="page.content"
      :class="[page.content.type, {protected: page.content.isProtected}]">
      <div class="mediaWrapper">
        <div class="mediaCnt" :class="{noImg: !page.content.useHeaderImg}">
          <div class="videoWrapper">
            <template v-if="['video', 'audio'].includes(page.content.type)">
              <div class="videoCover" v-if="page.content.media[lang]
                && page.content.thumbHd[lang] && !videoPlaying"
                :style="{'background-image': `url(${page.content.thumbHd[lang]})`}"
                :class="page.content.coverStyle" v-on:click="playVideo"></div>
            </template>
            <template v-else-if="page.content.type === 'gallery'">
              <div class="mediaGallery" v-if="page.content.gallery[lang]
                && page.content.gallery[lang].length > 0">
                <div class="theImg" :style="{'background-image':
                  `url(${page.content.gallery[lang][gi].imageMd})`}" v-on:click="previewImgObject"></div>
                <div class="galleryNav p" v-if="gi > 0"
                  v-on:click.stop="gi -= 1"></div>
                <div class="galleryNav n" v-if="gi < page.content.gallery[lang].length - 1"
                  v-on:click.stop="gi += 1"></div>
                <div class="galleryPager" v-on:click.stop="doNothing">
                  <div class="pagerItem" v-for="(item, i) in page.content.gallery[lang]" :key="i"
                    v-on:click.stop="gi = i"
                    :class="{active: i === gi}"></div>
                </div>
                <div class="downloadCnt">
                  <a :href="page.content.gallery[lang][gi].imageLg" target="_blank" download
                    class="btn download" v-on:click="download">Download</a>
                  <button class="btn openSlide" v-on:click="previewImgObject"></button>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="mediaImg" v-if="page.content.thumbHd && page.content.thumbHd[lang]">
                <img :src="page.content.thumbHd[lang]">
              </div>
              <div class="mediaImg noImg" v-else></div>
            </template>
            <div class="mediaContent video" v-if="page.content.type === 'video'
              && page.content.media[lang] && page.content.media[lang].mimetype === 'video/youtube'">
              <iframe :src="page.content.embedUri[lang]" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media;
                gyroscope; picture-in-picture" allowfullscreen autoplay ref="youtube"></iframe>
            </div>
            <div class="mediaContent video" v-else-if="page.content.type === 'video'">
              <VuePlyr ref="video" :options="{ hideControls: false }">
                <video></video>
              </VuePlyr>
            </div>
            <div class="mediaContent audio" v-else-if="page.content.type === 'audio' && showMedia">
              <VuePlyr ref="audio" :options="{ hideControls: false }">
                <video></video>
              </VuePlyr>
            </div>
            <div class="protectedContent" v-if="page.content.isProtected"
              :style="{'background-image': `url(${(page.content.type === 'gallery') ? page.content.thumbHd[lang] : 'qwe'}`}">
              <div class="protectedContentIn">
                <img src="../assets/padlock-white.png">
                <h4 v-if="lang === 'en'">Locked Content</h4>
                <h4 v-if="lang === 'id'">Konten Terkunci</h4>
              </div>
            </div>
          </div>
          <div class="mediaInfo">
            <h4>{{page.content.title[lang]}}</h4>
            <div class="authorInfo" v-if="page.content.displayAuthor
              || page.content.displayPublishDate || page.content.displayViews"
              :class="{noAuthor: !page.content.displayAuthor}">
              <div class="authorImg"></div>
              <h4 v-if="page.content.author && page.content.displayAuthor">
                {{page.content.author.name}}</h4>
              <div class="publishTime"
                v-if="page.content.displayPublishDate || page.content.displayViews">
                <span class="timestamp" v-if="page.content.publishDate
                  && page.content.displayPublishDate">
                  {{page.content.publishDate | moment(page.content.dateFormat)}}
                </span>
                <span class="timestamp" v-if="page.content.displayViews">
                  <span class="bull" v-if="page.content.displayPublishDate">&bull;</span>
                  <template v-if="page.content.viewCount > 1">
                    <template v-if="page.content.viewCount >= 1000000000">
                      {{Math.floor(page.content.viewCount/1000000000).toLocaleString('id')}}b
                    </template>
                    <template v-else-if="page.content.viewCount >= 1000000">
                      {{Math.floor(page.content.viewCount/1000000).toLocaleString('id')}}m
                    </template>
                    <template v-if="page.content.viewCount >= 1000">
                      {{Math.floor(page.content.viewCount/1000).toLocaleString('id')}}k
                    </template>
                    <template v-else-if="page.content.viewCount">
                      {{page.content.viewCount.toLocaleString('id')}}
                    </template>
                    views
                  </template>
                  <template v-else>{{page.content.viewCount || 0}} view</template>
                </span>
              </div>
            </div>
            <div class="protectedContent" v-if="page.content.isProtected">
              <div class="protectedContentIn">
                <img src="../assets/padlock.png">
                <h4>
                  <template v-if="lang === 'id'">Konten Terkunci</template>
                  <template v-if="lang === 'en'">Locked Content</template>
                </h4>
                <p v-if="page.content.hasPassword">
                  <template v-if="lang === 'id'">
                    Mohon masukan password untuk membuka konten ini
                  </template>
                  <template v-if="lang === 'en'">
                    Please input password to unlock this content
                  </template>
                </p>
                <p v-else>
                  <template v-if="lang === 'id'">
                    Kamu tidak mempunyai hak akses untuk membuka konten ini
                  </template>
                  <template v-if="lang === 'en'">
                    You dont have right to access this content
                  </template>
                </p>
                <form v-if="page.content.hasPassword"
                  v-on:submit.prevent="unlockContent">
                  <div class="fieldGroup" :class="{hasError: form.password.error}">
                    <input type="password" placeholder="Password..." class="field"
                      v-model="form.password.model" :disabled="passwordLoading"
                      v-on:input="form.password.error = null" ref="password">
                    <button type="submit" class="btn primary"
                      :class="{loading: passwordLoading}">
                      <span>Unlock</span>
                    </button>
                    <div class="fieldError" v-if="form.password.error">
                      {{form.password.error}}
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <template v-else>
              <div class="infoItem" :key="`meta${i}`"
                v-for="(meta, i) in page.content.metadata">
                <div class="infoLabel">{{meta.label[lang]}}</div>
                <div class="infoValue" v-if="meta.value[lang]">{{meta.value[lang]}}</div>
                <div class="infoValue" v-else>-</div>
              </div>
              <div class="infoContent" v-if="page.content.description"
                v-html="page.content.content[lang]"></div>
              <Attachment :attachments="page.content.attachments[lang]"
                v-if="page.content.attachments[lang]
                && page.content.attachments[lang].length > 0"></Attachment>
            </template>
          </div>
          <div class="mediaAction" v-if="page.content.media && page.content.media[lang]
            && ['pdf', 'file'].includes(page.content.type) && !page.content.isProtected">
            <button class="btn primary" v-if="page.content.type === 'pdf'"
              v-on:click="previewMedia">
              <template v-if="lang === 'id'">Pratinjau</template>
              <template v-else>Preview</template>
            </button>
            <a :href="page.content.media[lang].pdf" class="btn primary blue"
              v-if="page.content.media && page.content.media[lang].pdf
              && page.content.type === 'pdf'"
              download>
              <template v-if="lang === 'id'">Unduh</template>
              <template v-else>Download</template>
            </a>
            <a :href="page.content.media[lang].uri" class="btn primary blue"
              v-if="page.content.media && page.content.media[lang].uri
              && page.content.type === 'file'"
              download>
              <template v-if="lang === 'id'">Unduh</template>
              <template v-else>Download</template>
            </a>
          </div>
        </div>
      </div>
      <div class="articleShare articleShareStatic articleShareBottom"
        v-if="page.content.displayShare">
        <h4 v-if="lang === 'id'">Bagikan</h4>
        <h4 v-if="lang === 'en'">Share</h4>
        <div class="shareCnt">
          <a target="_blank"
            :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUri}`">
            <i class="fa fa-facebook fa-fw"></i>
          </a>
          <a target="_blank"
            :href="`https://twitter.com/intent/tweet?text=${page.content.title}&amp;url=${shareUri}`">
            <i class="fa fa-twitter fa-fw"></i>
          </a>
          <a :href="`whatsapp://send?text=${page.content.title} ${shareUri}`">
            <i class="fa fa-whatsapp fa-fw"></i>
          </a>
          <a target="_blank"
            :href="`https://telegram.me/share/url?url=${shareUri}&amp;text=${page.content.title}`">
            <i class="fa fa-telegram fa-fw"></i>
          </a>
          <a :href="`mailto:?subject=${page.content.title}&amp;body=Check this out:
            <a href='${shareUri}'>${page.content.title}</a>`">
            <i class="fa fa-email fa-fw"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="sectionCnt" v-if="page.content.sectionData && page.content.sectionData.length > 0
      && !page.content.isProtected"
      :class="page.content.type">
      <Page :page="{page: {sectionData: page.content.sectionData, id: page.content.id, uri: '/article'}}"/>
    </div>

    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <MediaPreview ref="mediaPreview"/>
  </section>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import Page from '@/components/Page.vue';
import MediaPreview from '@/components/MediaPreview.vue';
import Attachment from '@/components/Attachment.vue';

export default {
  components: {
    Confirmation,
    Snackbar,
    MediaPreview,
    Page,
    VuePlyr,
    Attachment,
  },
  props: ['page'],
  data() {
    return {
      scrolled: false,
      notFound: false,
      parent: null,
      loading: true,
      cat: null,
      detail: null,

      moreOpen: false,
      shareUri: '',
      related: [],
      shareTop: 0,
      scrollPrc: 0,
      showShare: false,
      baseShareTop: 0,
      baseEndTop: 0,
      loggedIn: false,
      showMedia: true,
      videoPlaying: false,

      /**
       * Form for password protected content
       *
       */
      passwordLoading: false,
      form: {
        password: { model: '', error: null },
      },

      /**
       * Gallery
       *
       */
      gi: 0,

      /**
       * Comment
       *
       */
      pPos: { x: 0, y: 0, show: false },
      showComment: false,
      loadingComment: false,
      loadingCommentThumb: false,
      commentModel: '',
      replyTo: null,
      highlighted: '',
      selectedtext: '',
      comments: [],
      commentLoaded: false,
      chatScrolled: false,
      commentMore: null,
      imgPreview: null,
      attachment: null,
      attFilename: '',
      emojiOpen: false,
      commentLimit: 12,
      commentPage: 0,
      loadingMoreComment: false,
      canLoadMore: true,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      this.pPos.show = false;
      this.emojiOpen = false;
      this.commentMore = null;
    },
    unlockContent() {
      if (!this.form.password.model) {
        this.form.password.error = (this.lang === 'id')
          ? 'Mohon masukan password' : 'Please input password';
        return;
      }
      this.passwordLoading = true;
      const uri = `article/${this.page.content.id}/unlock`;
      this.$http.post(this.$config.uri(uri), {
        password: this.form.password.model,
      }).then((r) => {
        this.passwordLoading = false;
        if (r.data.status !== 200) {
          this.form.password.error = (this.lang === 'id')
            ? 'Password yang kamu masukan salah'
            : 'Wrong password';
          setTimeout(() => {
            this.$refs.password.focus();
          });
          return;
        }
        this.page.content.isProtected = false;

        const { data } = r.data;
        this.page.content.content = data.content;
        this.page.content.thumb = data.thumb;
        this.page.content.thumbHd = data.thumbHd;
        this.page.content.metadata = data.metadata;
        this.page.content.linkUrl = data.linkUrl;
        this.page.content.eventDate = data.eventDate;
        this.page.content.eventDate2 = data.eventDate2;
        this.page.content.headerImg = data.headerImg;
        this.page.content.media = data.media;
        this.page.content.gallery = data.gallery;
        this.processContent();
      });
    },
    previewMedia() {
      this.$refs.mediaPreview.open({
        lang: this.lang,
        content: this.page.content,
      });
    },
    previewImgObject() {
      const viewerOptions = {
        url: 'imageLg',
        title: false,
        movable: false,
        zoomOnWheel: false,
        slideOnTouch: true,
      };
      if (this.page.content.type === 'gallery') {
        viewerApi({
          options: viewerOptions,
          images: this.page.content.gallery,
        });
      } else {
        viewerApi({
          options: viewerOptions,
          images: [page.content.imageMd],
        });
      }
    },
    escape(val) { return escape(val); },
    embed() {
      this.moreOpen = false;
      this.$refs.embedDialog.open(this.detail);
    },
    share() {
      this.moreOpen = false;
      this.$refs.shareDialog.open(this.detail, {
        page: this.currentPage,
        session: this.sessionId,
      });
    },
    download() {
      this.moreOpen = false;
      if (this.page.content.type === 'video') {
        this.$refs.downloadSelector.open(this.detail, this.sessionId);
        return;
      }
      const alUri = `content/${this.page.content.id}/download?session=${this.sessionId}&page=${this.currentPage}`;
      this.$http.get(this.$config.uri(alUri)).then(() => {});
    },
    onScrolled() {
      const scrollTop = window.scrollY || window.pageYOffset;
      if (this.$refs.endArticle) {
        const aHRect = this.$refs.endArticle.getBoundingClientRect();
        if (scrollTop + 120 < this.baseShareTop) {
          this.shareTop = this.baseShareTop;
        } else if (aHRect.top > 400) {
          this.shareTop = 120 + scrollTop;
        }
        const scrollPercent = scrollTop / this.baseEndTop;
        this.scrollPrc = Math.round(scrollPercent * 100);
        if (this.scrollPrc > 100 || this.scrollPrc < 0) this.scrollPrc = 100;
      }
    },
    playPauseAudio() {
      const v = this.$refs.audio.player;
      if (v.playing) v.pause();
      else v.play();
    },
    minimizeAudio() {
      const v = this.$refs.audio.player;
      if (v.playing) v.pause();
      this.$emit('play', {
        id: this.page.content.id,
        startAt: this.$refs.audio.player.currentTime,
        title: this.page.content.title,
        thumb: this.page.content.thumb,
        audio: {
          title: this.page.content.title,
          url: this.page.content.media.uri,
        },
      });
    },
    changeBaseShareTop() {
      const scrollTop = window.scrollY || window.pageYOffset;
      const contentRect = this.$refs.contentHelper.getBoundingClientRect();
      setTimeout(() => {
        this.shareTop = contentRect.top + scrollTop;
        this.baseShareTop = contentRect.top + scrollTop;
      });
    },
    playVideo() {
      if (this.page.content.isProtected) return;
      if (this.page.content.type === 'audio') {
        const { player } = this.$refs.audio;
        if (player.paused) player.play();
        else player.pause();
        return;
      }
      this.videoPlaying = true;
      if (this.page.content.media[this.lang].mimetype === 'video/youtube') {
        const { youtube } = this.$refs;
        if (youtube) youtube.src += (youtube.src.indexOf('?') >= 0) ? '&autoplay=1' : '?autoplay=1';
      } else {
        const { player } = this.$refs.video;
        if (player) player.play();
      }
    },
    processContent() {
      /**
       * Share url
       *
       */
      this.shareUri = `${this.$config.appUri}${this.$route.fullPath}`;

      /**
       * Get comment data
       *
       */
      // this.getComments();

      if (this.page.content.type === 'video') {
        if (!this.page.content.media[this.lang]) {
          this.showMedia = false;
          return;
        }
        const media = this.page.content.media[this.lang];
        if (media && media.mimetype === 'video/youtube') return;
        const src = [];
        if (media.vid1080p) src.push({ src: media.vid1080p, type: 'video/mp4', size: 1080 });
        if (media.vid720p) src.push({ src: media.vid720p, type: 'video/mp4', size: 720 });
        if (media.vid480p) src.push({ src: media.vid480p, type: 'video/mp4', size: 480 });
        if (media.vid360p) src.push({ src: media.vid360p, type: 'video/mp4', size: 360 });
        setTimeout(() => {
          const { player } = this.$refs.video;
          player.source = { type: 'video', title: this.page.content.title[this.lang], sources: src };
          // player.play();
        });
      } else if (this.page.content.type === 'audio') {
        if (!this.page.content.media[this.lang]) {
          this.showMedia = false;
          return;
        }
        const media = this.page.content.media[this.lang];
        const src = [{ src: media.audio, type: media.mimetype }];
        setTimeout(() => {
          const { player } = this.$refs.audio;
          player.source = { type: 'audio', title: this.page.content.title, sources: src };
          // player.play();
        });
      } else if (this.page.content.type === 'article') {
        /**
         * Share position
         *
         */
        const scrollTop = window.scrollY || window.pageYOffset;
        const contentRect = this.$refs.contentHelper.getBoundingClientRect();
        const aHRect = this.$refs.endArticle.getBoundingClientRect();
        setTimeout(() => {
          this.shareTop = contentRect.top + scrollTop;
          this.baseShareTop = contentRect.top + scrollTop;
          this.baseEndTop = (aHRect.top + scrollTop) - (window.innerHeight / 1.5);
          this.showShare = true;
        });

        /**
         * Reading time
         *
         */
        setTimeout(() => {
          const minsRead = (this.lang === 'id') ? 'menit baca' : 'mins read';
          const lessThanAMinutes = (this.lang === 'id')
            ? 'kurang dari satu menit' : 'less than a minutes read';
          ReadingTime(270, '', minsRead, '', lessThanAMinutes);
        }, 200);
      }

      /**
       * Get related content
       *
       */
      // const relatedUri = `article/all?parentId=${this.page.content.parent.id}&related=${this.page.content.id}&limit=4`;
      // this.$http.get(this.$config.uri(relatedUri)).then((r) => {
      //   this.related = (r.data.status === 200) ? r.data.data : [];
      // });
    },
    getData() {
      // const { code } = this.$route.params;
      // if (!code) {
      //   const { id } = this.$route.params;
      //   const { _sign } = this.$route.query;
      //   if (id && _sign) {
      //     axios.get(`${process.env.VUE_APP_API_URI}article/all?id=${id}&sign=${_sign}`, {
      //       headers: {
      //         Key: process.env.VUE_APP_API_KEY,
      //       },
      //     }).then((r) => {
      //       this.loading = false;
      //       if (r.data.status !== 200) {
      //         return;
      //       }
      //       this.detail = r.data.data;
      //       document.title = `${this.page.content.title} - ${process.env.VUE_APP_APP_NAME}`;
      //       setTimeout(() => {
      //         this.processContent();
      //       });
      //     });
      //   } else {
      //     this.loading = false;
      //   }
      // } else {
      //   axios.get(`${process.env.VUE_APP_API_URI}article/all?code=${code}`, {
      //     headers: {
      //       Key: process.env.VUE_APP_API_KEY,
      //     },
      //   }).then((r) => {
      //     this.loading = false;
      //     if (r.data.status !== 200) {
      //       return;
      //     }
      //     this.detail = r.data.data;
      //     document.title = `${this.page.content.title} - ${process.env.VUE_APP_APP_NAME}`;
      //     setTimeout(() => {
      //       this.processContent();
      //     });
      //   });
      // }
    },

    /**
     * Comment
     *
     */
    reportComment(item) {
      this.commentMore = null;
      this.$refs.confirmDialog.open({
        title: 'Report Comment',
        desc: 'Please input report information about this comment below',
        inputs: [
          {
            type: 'longtext',
            label: 'Report reason',
            value: '',
            error: null,
            isRequired: true,
          },
        ],
        action: 'Submit Report',
      }, (b, c, d, v) => {
        if (!b) return;
        this.$refs.confirmDialog.open({
          title: 'Report Submited',
          desc: 'We will review your report as soon as possible and take immediate action.',
          successAnimation: true,
          error: true,
        });
        axios.post(`${process.env.VUE_APP_API_URI}comment/${item.id}/report`, {
          reason: v[0].value,
        }, {
          headers: {
            Key: process.env.VUE_APP_API_KEY,
            Authoziration: localStorage.getItem('briguide_jwt'),
          },
        }).then((r) => {});
      });
    },
    selectEmoji(emoji) {
      const el = this.$refs.comment;
      el.innerHTML = `${el.innerHTML.trim()} ${emoji.data}`;
      this.commentModel = el.textContent;
    },
    reply(item) {
      this.replyTo = item;
      this.highlighted = '';
      this.$refs.comment.focus();
    },
    inputPasted(e) {
      e.preventDefault();
      const { items } = (e.originalEvent || e).clipboardData;
      const file = (e.originalEvent || e).clipboardData.files[0];
      if (file) {
        this.gotFile(file);
        return;
      }
      const text = (e.originalEvent || e).clipboardData.getData('text/plain');
      document.execCommand('insertHTML', false, text);
    },
    handleFile() {
      this.gotFile(this.$refs.file.files[0]);
    },
    gotFile(file) {
      if (file.type.split('/')[0] !== 'image'
        && file.type !== 'application/pdf') {
        this.$refs.confirmDialog.open({
          title: 'File Not Supported',
          desc: 'Only support image and pdf file for attachment',
          error: true,
          action: 'Close',
        });
        return;
      }
      this.attachment = file;
      this.attFilename = file.name;
      if (file.type.split('/')[0] === 'image') {
        const reader = new FileReader();
        reader.onload = () => {
          this.imgPreview = reader.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.imgPreview = 'pdf';
      }
    },
    openComment() {
      if (this.loading) return;
      this.showComment = true;
      this.getComments();
      setTimeout(() => {
        this.$refs.comment.focus();
      }, 350);
    },
    loadMoreComment(next) {
      this.commentPage += 1;
      this.getComments(true, next);
    },
    getComments(fromLoadMore, next) {
      if (this.loadingComment) return;
      if (fromLoadMore) {
        this.loadingMoreComment = true;
      } else {
        this.canLoadMore = true;
        this.loadingComment = true;
        this.commentLoaded = false;
        this.comments = [];
        this.highlighted = '';
        this.replyTo = null;
      }
      const uri = `comment/all?articleId=${this.page.content.id}&fe=y&page=${this.commentPage}&limit=${this.commentLimit}`;
      axios.get(`${process.env.VUE_APP_API_URI}${uri}`, {
        headers: {
          Key: process.env.VUE_APP_API_KEY,
          Authoziration: localStorage.getItem('briguide_jwt'),
        },
      }).then((r) => {
        this.loadingComment = false;
        this.loadingMoreComment = false;
        if (fromLoadMore) {
          if (r.data.status === 200) this.comments.unshift(...r.data.data);
          else this.canLoadMore = false;
          if (r.data.data.length < this.commentLimit) this.canLoadMore = false;
        } else {
          this.comments = (r.data.status === 200) ? r.data.data : [];
          if (this.comments.length < this.commentLimit) this.canLoadMore = false;
          setTimeout(() => {
            this.scrollWrapper();
          }, 50);
        }
        if (next) next();
        setTimeout(() => {
          this.commentLoaded = true;
        }, 1000);
      });
    },
    scrollWrapper() {
      setTimeout(() => {
        if (!this.$refs.wrapper) return;
        this.$refs.wrapper.scrollTo(0, this.$refs.wrapper.scrollHeight);
      });
    },
    sendComment() {
      if (!this.loggedIn) {
        this.$emit('login', null);
        this.showComment = false;
        return;
      }

      const content = this.commentModel;
      if ((!content || content.trim() === '') && !this.imgPreview) return;

      const replyTo = this.replyTo ? this.replyTo.id : null;
      let att = null;
      if (this.imgPreview === 'pdf') {
        att = {
          type: 'pdf',
          uri: null,
          filename: this.attFilename,
          error: false,
        };
      } else if (this.imgPreview) {
        att = {
          type: 'image',
          uri: this.imgPreview,
          filename: this.attFilename,
          error: false,
        };
      }

      const comment = {
        id: null,
        isDeleted: 0,
        user: {
          name: localStorage.getItem('briguide_name'),
        },
        articleId: this.page.content.id,
        me: true,
        content: content.trim(),
        dateCreated: Math.floor(Date.now() / 1000),
        selectedText: this.highlighted,
        replyTo: this.replyTo,
        selectedType: 'article',
        attachments: att,
      };
      this.comments.push(comment);
      this.scrollWrapper();

      /**
       * Send comment to API
       *
       */
      axios.post(`${process.env.VUE_APP_API_URI}comment/send`, {
        content: content.trim(),
        articleId: this.page.content.id,
        highlighted: this.highlighted,
        hlType: 'article',
        replyTo,
      }, {
        headers: {
          Key: process.env.VUE_APP_API_KEY,
          Authoziration: localStorage.getItem('briguide_jwt'),
        },
      }).then((r) => {
        comment.id = r.data.id;
        if (this.imgPreview) {
          this.imgPreview = null;
          // Upload image to server
          const formData = new FormData();
          formData.append('file', this.attachment);
          axios.post(`${process.env.VUE_APP_API_URI}comment/${comment.id}/attachment`, formData, {
            headers: {
              Key: process.env.VUE_APP_API_KEY,
              Authoziration: localStorage.getItem('briguide_jwt'),
              'Content-Type': 'multipart/form-data',
            },
          }).then((r2) => {
            if (r2.data.status !== 200) {
              att.error = true;
              return;
            }
            att.uri = r2.data.uri;
          });
        }
      });

      this.replyTo = null;
      this.highlighted = '';
      this.commentModel = '';
      this.$refs.comment.innerHTML = '';
    },
    commentKeydown(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.sendComment();
      }
    },
    commentChanged(e) {
      this.commentModel = e.target.textContent;
    },
    hlClicked(item) {
      // Do highlight highlighted word
    },
    deleteComment(item) {
      this.commentMore = null;
      this.$refs.confirmDialog.open({
        title: 'Delete Comment',
        desc: 'Are you sure you want to delete this comment?',
      }, (b) => {
        if (!b) return;
        item.isDeleted = 1;
        item.content = 'This comment was deleted';
        item.attachments = null;
        item.replyTo = null;
        axios.get(`${process.env.VUE_APP_API_URI}comment/${item.id}/delete`, {
          headers: {
            Key: process.env.VUE_APP_API_KEY,
            Authoziration: localStorage.getItem('briguide_jwt'),
          },
        }).then((r) => {
          this.$refs.snackbar.open({ content: 'Comment has been deleted' });
        });
      });
    },
    openReply(item) {
      const el = document.getElementById(`comment-${item.id}`);
      if (!el) {
        this.loadMoreComment(() => {
          const el2 = document.getElementById(`comment-${item.id}`);
          if (!el2) {
            this.loadMoreComment(() => {
              const el3 = document.getElementById(`comment-${item.id}`);
              if (!el3) {
                this.loadMoreComment(() => {
                  const el4 = document.getElementById(`comment-${item.id}`);
                  if (el4) {
                    setTimeout(() => {
                      this.hlReply(item);
                    }, 200);
                  }
                });
              } else {
                setTimeout(() => {
                  this.hlReply(item);
                }, 100);
              }
            });
          } else {
            setTimeout(() => {
              this.hlReply(item);
            }, 50);
          }
        });
      } else {
        this.hlReply(item);
      }
    },
    hlReply(item) {
      const el = document.getElementById(`comment-${item.id}`);
      el.scrollIntoView(false);
      el.classList.remove('rp-clicked');
      setTimeout(() => {
        el.classList.add('rp-clicked');
        setTimeout(() => {
          el.classList.remove('rp-clicked');
        }, 3000);
      }, 100);
    },
    comment() {
      this.highlighted = this.selectedtext;
      this.showComment = true;
      this.pPos.show = false;
      setTimeout(() => {
        this.$refs.comment.focus();
      }, 350);
    },
    tweet() {
      const text = encodeURIComponent(`“${this.selectedtext}...”`);
      const contentUri = `${process.env.VUE_APP_BASE_URI}page/${this.page.content.parent.code}/${this.page.content.code}`;
      const uri = `https://twitter.com/intent/tweet?text=${text}&url=${contentUri}`;
      window.open(uri, '_blank').focus();
    },
    mouseUpEvent() {
      this.getSelectedText((selectedtext, oRect) => {
        if (!selectedtext || selectedtext.trim() === '') return;
        this.selectedtext = selectedtext;
        const scrollTop = window.scrollY || window.pageYOffset;
        setTimeout(() => {
          this.pPos.x = oRect.x + (oRect.width / 2);
          this.pPos.y = oRect.y + scrollTop;
          this.pPos.show = true;
        });
      });
    },
    getSelectionParentElement() {
      let parentEl = null;
      let sel;
      if (window.getSelection) {
        sel = window.getSelection();
        if (sel.rangeCount) {
          parentEl = sel.getRangeAt(0).commonAncestorContainer;
          if (parentEl.nodeType !== 1) {
            parentEl = parentEl.parentNode;
          }
        }
      } else if ((sel = document.selection) && sel.type !== 'Control') { // eslint-disable-line
        parentEl = sel.createRange().parentElement();
      }
      return parentEl;
    },
    isComentable(el, tried) {
      if (el && el.dataset && el.dataset.comment) return true;
      if (!el || tried > 15) return false;
      return this.isComentable(el.parentElement, tried + 1);
    },
    getSelectedText(next) {
      let selectedtext = null;
      if (window.getSelection) {
        selectedtext = window.getSelection().toString();
      } else if (document.selection) {
        selectedtext = document.selection.createRange().text;
      }

      /**
       * No text selected, skip
       *
       */
      if (!selectedtext || selectedtext.trim() === '') {
        next(null);
        return;
      }

      /**
       * Is selection on comentable text
       *
       */
      const parent = this.getSelectionParentElement();
      if (!this.isComentable(parent, 0)) {
        next(null);
        return;
      }

      /**
       * Show comment
       *
       */
      const oRange = window.getSelection().getRangeAt(0);
      const oRect = oRange.getBoundingClientRect();
      next(selectedtext, oRect);
    },
  },
  created() {
    window.addEventListener('mouseup', this.mouseUpEvent);
    window.addEventListener('scroll', this.onScrolled);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScrolled);
    window.removeEventListener('mouseup', this.mouseUpEvent);
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
    this.processContent();
  },
};
</script>

<style lang="scss">
.articleContent, .infoContent{
  font-size: 17px;
  line-height: 1.6;
  min-height: 180px;
  padding: 10px 0 0;
  *:not(table):not(tr):not(td):not(th) {
    background-color: unset !important;
    font-family: inherit !important;
  }
  blockquote{
    font-size: 26px;
    line-height: 1.3;
    border-left: #ddd 4px solid;
    position: relative;
    margin: 0;
    padding-bottom: 6px;
    color: #767676;
    padding-left: 50px;
    &:before{
      content: "\”";
      font-size: 80px;
      position: absolute;
      left: 8px; top: -18px;
    }
  }
  figure{
    margin: 0;
  }
  table{
    border-color: #ccc !important;
    border-width: 1px !important;
    width: 100% !important;
    font-family: inherit !important;
    td, th{
      border-width: 1px !important;
      border-color: #ccc !important;
      font-family: inherit !important;
      padding: 8px 12px !important;
    }
  }
  .wp-block-image.size-full{
    img{
      width: 100%;
      border-radius: 5px;
    }
  }
  ul, ol{
    margin: 0;
    padding-left: 30px;
    font-size: inherit !important;
    line-height: inherit !important;
    @media (max-width: 680px) {
      padding-left: 26px;
    }
    li{
      padding: 6px 0;
      padding-left: 10px;
      font-size: inherit !important;
      line-height: inherit !important;
      @media (max-width: 680px) {
        padding-left: 6px;
      }
    }
  }
  ul li{
    list-style: disc;
  }
  ol li{
    list-style: auto;
  }
  h2{
    margin: 0;
    font-size: 34px;
  }
  h3{
    margin: 0;
    font-size: 24px;
  }
  p{
    margin: 0;
    font-size: inherit !important;
  }
  span{
    font-size: inherit !important;
  }
  p.caption{
    margin: -14px 0 20px 10px;
    font-size: 15px;
    line-height: 1.4;
    min-height: 22px;
  }
  p.dropcaps:first-letter {
    float: left;
    font-size: 75px;
    line-height: 60px;
    padding-top: 4px;
    padding-right: 8px;
    margin-left: -5px;
  }
  p span{
    font-size: inherit !important;
  }
  a{
    font-weight: 600;
    color: #008552;
    &:hover{
      color: #006a42;
    }
  }
  pre{
    white-space: pre-wrap;
    font-family: Fira Code VF,ui-monospace,SFMono-Regular,Menlo,Monaco,
      Consolas,Liberation Mono,Courier New,monospace;
    font-size: 15px;
    background-color: #1e293b;
    color: #ccc;
    padding: 8px 12px;
    border-radius: 5px;
    margin: 0 0 4px;
    border-left: #555 10px solid;
  }
  .fontsizes{
    &.fs-4{
      font-size: 50% !important;
    }
    &.fs-3{
      font-size: 60% !important;
    }
    &.fs-2{
      font-size: 70% !important;
    }
    &.fs-1{
      font-size: 80% !important;
    }
    &.fs1{
      font-size: 120% !important;
    }
    &.fs2{
      font-size: 140% !important;
    }
    &.fs3{
      font-size: 180% !important;
    }
    &.fs4{
      font-size: 240% !important;
    }
  }
  .highlight{
    display: inline;
    background-color: yellow;
  }
  iframe.theMedia{
    height: 420px;
    border: none;
    @media (max-width: 700px){
      height: 200px;
    }
  }
  .theMedia{
    display: block;
    margin: 20px 0;
    width: 100%;
    border-radius: 5px;
    position: relative;
    z-index: 3;
    &.md-wide{
      width: calc(100% + 200px);
      margin: 20px -100px;
      @media (max-width: 974px) {
        width: calc(100% + 100px);
        margin: 20px -50px;
      }
      @media (max-width: 874px) {
        width: calc(100% + 40px);
        margin: 20px -20px;
        border-radius: 0;
      }
    }
  }
}
.profileInfo{
  .articleDetail{
    .content{
      .articleContent{
        font-size: 17px;
        @media (max-width: 1480px) {
          font-size: 16px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.pPos{
  position: absolute;
  background-color: #222;
  z-index: 17;
  padding: 4px;
  margin-top: -48px;
  margin-left: -106px;
  border-radius: 5px;
  box-shadow: 0 0 4px rgba(0, 0, 0, .2);
  display: none;
  &.open{
    display: flex;
  }
  &:before{
    content: "";
    position: absolute;
    bottom: -4px;
    border-top: #222 4px solid;
    border-left: transparent 4px solid;
    border-right: transparent 4px solid;
    left: 50%;
    transform: translateX(-50%);
  }
  li{
    list-style: none;
    position: relative;
    color: #fff;
    font-size: 13px;
    padding: 6px 12px;
    border-radius: 5px;
    padding-left: 40px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      background-color: rgba(255, 255, 255, .1);
    }
    img{
      position: absolute;
      left: 10px; top: 50%;
      height: 20px;
      transform: translateY(-50%);
    }
  }
}

.protectedContent{
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 0;
  .protectedContentIn{
    img{
      width: 64px;
      margin: 0 0 10px;
    }
    h4{
      margin: 0 0 4px !important;
      font-size: 20px !important;
      font-weight: 500;
    }
    p{
      margin: 0;
      font-size: 15px;
      color: #767676;
    }
    form{
      position: relative;
      padding: 14px 0 0;
      .fieldGroup{
        margin: 0;
        position: relative;
        .field{
          border-radius: 50px;
          padding-left: 22px;
          width: 360px;
        }
        .btn{
          position: absolute;
          right: 5px; top: 5px;
          border-radius: 50px;
          font-size: 17px;
          padding: 0 22px;
          font-weight: 400;
          height: 38px;
          &.loading{
            background-size: 28px auto;
          }
        }
      }
    }
  }
}

.loadingFull{
  height: 100vh;
}
.viewer-container{
  z-index: 99999 !important;
}
.articleDetail{
  // padding: 40px 0 40px;
  &.ad1{
    padding: 0;
  }
  &.ad2{
    padding: 0 0 80px;
    min-height: 400px;
  }
  .content{
    max-width: 750px;
    margin: 0 auto;
    @media (max-width: 960px) {
      max-width: none;
      margin: 0 20px;
    }
    .articleTitle{
      font-size: 40px;
      margin: 0;
      line-height: 1.2;
      margin-bottom: 20px;
      font-weight: 800;
    }
  }
  @media (max-width: 700px) {
    padding: 30px 0 30px;
    .content{
      .articleTitle{
        font-size: 24px;
        line-height: 1.3;
        margin-bottom: 10px;
      }
    }
  }
}

.articleHeaderImg{
  height: 34vw;
  background-size: cover;
  background-position: center;
  background-color: #ccc;
  background-repeat: no-repeat;
  max-width: 1140px;
  margin: 0 auto 30px;
  border-radius: 5px;
  @media (max-width: 1180px) {
    max-width: 960px;
  }
  @media (max-width: 1020px) {
    max-width: none;
    border-radius: 0;
    height: 36vw;
  }
  @media (max-width: 680px) {
    height: 46vw;
  }
  @media (max-width: 540px) {
    height: 220px;
  }
  &.full{
    background-image: none !important;
    height: auto;
    img{
      width: 100%;
      display: block;
      border-radius: 5px;
    }
  }
  &.noImg{
    background-color: #d5d5d5;
    background-image: url(../assets/no-img-big.jpg);
    background-size: contain;
    background-repeat: no-repeat;
    opacity: 1;
  }
  &.protected{
    position: relative;
    overflow: hidden;
    &:before{
      content: "";
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      background-color: #000;
      opacity: .24;
    }
    &.noImg{
      background-image: none !important;
      background-color: #ccc !important;
    }
    .protectedContent{
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      &:before{
        content: "";
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        background-color: #000;
        opacity: .18;
      }
      .protectedContentIn{
        position: relative;
        z-index: 3;
        img{
          width: 54px;
        }
        h4{
          margin: 0;
          font-weight: 400;
          font-size: 18px;
        }
      }
    }
  }
}
.label{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0;
  .labelItem{
    margin-right: 8px;
    margin-bottom: 8px;
    color: #767676;
    font-size: 16px;
  }
}
.contentLoading{
  padding-top: 60px;
}
.readTimePrc{
  position: fixed;
  left: 20px; bottom: 20px;
  z-index: 3;
  transition: all .5s ease;
  &.hidden{
    opacity: 0;
  }
}

@property --pgPercentage {
  syntax: '<number>';
  inherits: false;
  initial-value: 0;
}

div[role="progressbar"] {
  --size: 4rem;
  --fg: #369d66;
  --bg: #cae8d8;
  --pgPercentage: var(--value);
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  display: grid;
  place-items: center;
  background:
    radial-gradient(closest-side, white 80%, transparent 0 99.9%, white 0),
    conic-gradient(var(--fg) calc(var(--pgPercentage) * 1%), var(--bg) 0)
    ;
  font-family: Helvetica, Arial, sans-serif;
  font-size: calc(var(--size) / 5);
  color: var(--fg);
}

div[role="progressbar"]::before {
  counter-reset: percentage var(--value);
  content: counter(percentage) '%';
}

.relatedWrapper{
  max-width: 1180px;
  margin: 0 auto 60px;
  padding-top: 60px;
  @media (max-width: 1300px) {
    max-width: 1140px;
  }
  @media (max-width: 1220px) {
    margin: 0 20px 40px;
  }
  @media (max-width: 680px) {
    margin: 0 16px 20px;
  }
}
.relatedTitle{
  font-size: 24px;
  margin: 0 0 20px;
  font-weight: 800;
}
.relatedCnt{
  display: flex;
  margin: 0 -10px;
  flex-wrap: wrap;
  @media (max-width: 680px) {
    display: block;
    margin: 0;
  }
  .relatedItem{
    width: calc(25% - 20px);
    margin: 0 10px 40px;
    @media (max-width: 960px) {
      width: calc(33.333333333% - 20px);
    }
    @media (max-width: 680px) {
      width: auto;
      margin: 0 0 30px;
      padding-left: 68px;
      position: relative;
      min-height: 60px;
      box-sizing: border-box;
    }
    &.rt6, &.rt7{
      @media (max-width: 960px) {
        display: none;
      }
      @media (max-width: 680px) {
        display: block;
      }
    }
    .relatedImg{
      height: 180px;
      border-radius: 5px;
      background-size: cover;
      background-position: center;
      background-color: #ccc;
      background-repeat: no-repeat;
      margin-bottom: 10px;
      transition: all .2s ease;
      @media (max-width: 680px) {
        position: absolute;
        left: 0; top: 0;
        width: 60px; height: 60px;
        border-radius: 3px;
      }
      &.noImg{
        background-image: url(../assets/image-black.png);
        background-size: 46px auto;
        opacity: .36;
        @media (max-width: 680px) {
          background-size: 22px auto;
        }
      }
      &:hover{
        box-shadow: 4px 4px 0 #E8423B;
      }
    }
    img.relatedImg{
      height: auto;
      width: 100%;
    }
    a{
      text-decoration: none;
      color: #444;
      &:hover{
        color: #1E4180;
      }
    }
    h4{
      margin: 0;
      padding-left: 7px;
      font-weight: 600;
      line-height: 1.2;
      font-size: 18px;
      color: #E8423B;
      @media (max-width: 680px) {
        font-size: 15px;
      }
    }
  }
}

.authorInfo{
  position: relative;
  padding-top: 8px;
  // padding-left: 50px;
  padding-bottom: 30px;
  @media (max-width: 700px) {
    padding-bottom: 16px;
  }
  .authorImg{
    position: absolute;
    left: 0;
    top: 8px;
    width: 39px;
    height: 39px;
    background-color: #ccc;
    background-image: url(../assets/user.png);
    background-size: cover;
    border-radius: 50%;
    cursor: pointer;
    display: none;
  }
  h4{
    margin: 0 0 2px !important;
    font-size: 17px !important;
  }
  .publishTime{
    margin: 0;
    font-size: 14px;
    .bull{
      margin: 0 6px;
    }
    .reading-time__word-count{
      display: none;
    }
  }
}

.articleBottom{
  padding: 30px 0 0;
  .articleBottomCnt{
    border-top: #999 1px solid;
    max-width: 750px;
    margin: 0 auto;
    padding: 30px 0 0;
    @media (max-width: 960px) {
      max-width: none;
      margin: 0 20px;
    }
    .tags{
      display: flex;
      flex-wrap: wrap;
      padding: 0 0 30px;
      .tagItem{
        font-size: 14px;
        font-weight: 500;
        margin: 0 10px 10px 0;
        color: #444;
        border: #ddd 1px solid;
        &:hover{
          background-color: #008552;
          color: #fff;
        }
      }
    }
  }
}

.articleShare{
  position: absolute;
  top: 160px;
  left: calc(((100% - 750px) / 2) - 80px);
  padding: 0 10px 5px;
  background-color: #f5f5f5;
  border-radius: 5px;
  margin-top: 10px;
  @media (max-width: 960px) {
    margin-left: 20px;
  }
  &.articleShareStatic{
    padding-top: 0;
    padding-bottom: 20px;
    margin-left: 0;
    display: flex;
    @media (min-width: 975px) {
      display: none;
    }
    &.articleShareBottom{
      display: block;
      height: auto;
      position: static;
      padding: 0;
      margin: 0;
      h4{
        text-align: left;
        margin: 0;
        text-transform: none;
        font-size: 16px;
      }
      .shareCnt{
        display: flex;
        flex-wrap: wrap;
        margin-left: -6px;
        a{
          margin: 0;
          margin-right: 10px;
        }
      }
    }
    &.articleShareStaticMedia{
      display: flex !important;
      position: static;
      left: 0; top: auto;
      transform: none;
      border-radius: 0;
      flex-wrap: wrap;
      padding: 0 0 20px;
      margin: 0;
      h4{
        padding: 0;
        width: 100%;
        text-align: left;
        margin: 0;
        font-size: 17px;
        text-transform: none;
      }
      .shareCnt{
        display: flex;
        margin-left: -5px;
        a{
          margin: 0;
          margin-right: 10px;
          padding: 0;
          .fa{
            margin: 0;
          }
        }
      }
    }
  }
  h4{
    margin: 0 0 10px;
    font-size: 10px;
    text-align: center;
    text-transform: uppercase;
    color: #767676;
  }
  a{
    display: block;
    .fa{
      width: 40px;
      height: 40px;
      display: block;
      border-radius: 50%;
      margin: 0 auto;
      margin-top: 4px;
      background-size: 26px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .5;
      &:hover{
        background-color: #fff;
        opacity: 1;
      }
    }
    .fa.fa-facebook{
      background-image: url(../assets/share-facebook.png);
    }
    .fa.fa-twitter{
      background-image: url(../assets/share-x.png);
    }
    .fa.fa-whatsapp{
      background-image: url(../assets/share-whatsapp.png);
    }
    .fa.fa-telegram{
      background-image: url(../assets/share-telegram.png);
    }
    .fa.fa-email{
      background-image: url(../assets/share-email.png);
    }
  }
  @media (max-width: 974px) {
    position: static;
    display: flex;
    left: 0;
    top: auto;
    transform: none;
    bottom: 70px;
    border-radius: 0;
    flex-wrap: wrap;
    padding: 20px 0 0;
    display: none;
    h4{
      width: 50px;
      padding-top: 6px;
      width: 100%;
      text-align: left;
      margin-bottom: 6px;
      font-size: 17px;
      text-transform: none;
    }
    .shareCnt{
      display: flex;
      margin-left: -5px;
      a{
        margin: 0;
        margin-right: 10px;
        padding: 0;
        .fa{
          margin: 0;
        }
      }
    }
  }
}

.preview{
  z-index: 991;
  padding: 10px 0;
  position: fixed;
  left: 0; right: 0;
  text-align: center;
  background-color: rgba(255, 255, 0, .65);
  backdrop-filter: blur(30px);
  color: #222;
  top: 86px;
  @media (max-width: 1480px) {
    top: 64px;
  }
  @media (max-width: 768px) {
    top: 56px;
  }
}

.articleDetailCnt{
  &.event{
    padding: 0 0 60px;
    max-width: 780px;
    margin: 0 auto;
    @media (max-width: 840px) {
      max-width: none;
      margin: 0 20px;
    }
    @media (max-width: 640px) {
      margin: 0;
    }
    .eventHeader{
      height: 400px;
      background-color: #d5d5d5;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      @media (max-width: 840px) {
        height: 56vw;
      }
      @media (max-width: 640px) {
        height: 64vw;
      }
      &.full{
        height: auto;
        background-color: #ddd;
        overflow: hidden;
        img{
          display: block;
          width: 100%;
        }
      }
      &.noImg{
        background-image: url(../assets/no-img-big.jpg);
        background-size: contain;
      }
      &.protected{
        position: relative;
        .protectedContent{
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          &:before{
            content: "";
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            background-color: #000;
            opacity: .18;
          }
          .protectedContentIn{
            position: relative;
            z-index: 3;
            img{
              width: 54px;
            }
            h4{
              margin: 0;
              font-weight: 400;
              font-size: 18px;
            }
          }
        }
      }
    }
    .eventCnt{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,.125);
      border-radius: 7px;
      box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,.075);
      overflow: hidden;
      @media (max-width: 640px) {
        box-shadow: none;
        border: none;
        border-radius: 0;
      }
    }
    .eventInfo{
      padding: 20px 30px;
      @media (max-width: 640px) {
        padding: 20px;
      }
      .eventBtn{
        min-width: 160px;
        text-align: center;
        margin: 0 0 30px;
        @media (max-width: 640px) {
          width: 100%;
        }
      }
      h4{
        margin: 0 0 16px;
        font-size: 30px;
        line-height: 1.3;
        @media (max-width: 960px) {
          font-size: 26px;
        }
        @media (max-width: 860px) {
          font-size: 22px;
        }
        @media (max-width: 640px) {
          font-size: 18px;
        }
      }
      .protectedContent{
        margin-top: -30px;
      }
      .infoItem{
        display: flex;
        padding: 0 0 10px;
        font-size: 17px;
        @media (max-width: 960px) {
          font-size: 16px;
        }
        @media (max-width: 640px) {
          display: block;
          padding: 0 0 14px;
        }
        .infoLabel{
          font-weight: 500;
          color: #008552;
          width: 150px;
          box-sizing: border-box;
          @media (max-width: 640px) {
            width: auto;
          }
        }
        .infoValue{
          width: calc(100% - 150px);
          box-sizing: border-box;
          @media (max-width: 640px) {
            width: auto;
          }
        }
      }
    }
    .articleShare.articleShareBottom{
      padding-top: 20px;
      @media (max-width: 640px) {
        padding-left: 20px;
      }
    }
  }
  &.media{
    padding: 0 0 60px;
    max-width: 920px;
    margin: 0 auto;
    @media (max-width: 980px) {
      max-width: none;
      margin: 0 20px;
    }
    @media (max-width: 640px) {
      margin: 0;
    }
    .mediaCnt{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,.125);
      border-radius: 0.25rem;
      box-shadow: 0 0.125rem 0.25rem rgba(0,0,0,.075);
      position: relative;
      display: flex;
      padding: 20px;
      flex-wrap: wrap;
      @media (max-width: 640px) {
        display: block;
        border: none;
        box-shadow: none;
        border-radius: 0;
      }
      .infoContent{
        margin-top: 0;
        padding-top: 0;
      }
      .videoWrapper{
        position: relative;
      }
      .mediaImg{
        width: 260px;
        @media (max-width: 860px) {
          width: 200px;
        }
        @media (max-width: 640px) {
          width: auto;
        }
        img{
          width: 100%;
          height: auto;
          border-radius: 3px;
          display: block;
        }
        &.noImg{
          background-image: url(../assets/icel-logo-grey.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 76px auto;
          opacity: .64;
          height: 340px;
          background-color: #eee;
        }
      }
      .mediaInfo{
        padding: 10px 20px 10px 30px;
        box-sizing: border-box;
        width: calc(100% - 260px);
        @media (max-width: 860px) {
          width: calc(100% - 200px);
        }
        @media (max-width: 640px) {
          width: auto;
          padding: 16px 6px 20px;
        }
        h4{
          margin: 0 0 16px;
          font-size: 30px;
          line-height: 1.3;
          @media (max-width: 960px) {
            font-size: 26px;
          }
          @media (max-width: 860px) {
            font-size: 22px;
          }
          @media (max-width: 640px) {
            font-size: 20px;
          }
        }
        .authorInfo{
          h4{
            margin: 0 0 2px;
            font-size: 17px;
          }
        }
        .protectedContent{
          margin-top: -30px;
        }
        .infoItem{
          display: flex;
          padding: 0 0 10px;
          font-size: 17px;
          @media (max-width: 960px) {
            font-size: 16px;
          }
          @media (max-width: 640px) {
            display: block;
            padding: 0 0 14px;
          }
          .infoLabel{
            font-weight: 500;
            color: #008552;
            width: 150px;
            box-sizing: border-box;
            @media (max-width: 640px) {
              width: auto;
            }
          }
          .infoValue{
            width: calc(100% - 150px);
            box-sizing: border-box;
            @media (max-width: 640px) {
              width: auto;
            }
          }
        }
      }
      &.noImg{
        display: block;
        .mediaImg{
          display: none;
        }
        .mediaInfo{
          width: auto;
          padding: 0;
        }
      }
      .mediaAction{
        width: 100%;
        border-top: #ccc 1px solid;
        margin-top: 20px;
        padding-top: 20px;
        display: flex;
        justify-content: flex-end;
        @media (max-width: 640px) {
          margin: 0 -20px -10px;
          padding: 10px 20px 0;
          width: auto;
          display: block;
        }
        .btn{
          border-radius: 5px;
          margin-left: 10px;
          padding: 14px 24px;
          padding-right: 70px;
          font-weight: 500;
          position: relative;
          overflow: hidden;
          @media (max-width: 640px) {
            width: 100%;
            margin: 6px 0;
          }
          &:before{
            content: "";
            position: absolute;
            right: 0; top: 0; bottom: 0;
            width: 48px;
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(../assets/search-bold-white.png);
            background-color: #006a42;
          }
          &.blue{
            background-color: #284af5;
            &:before{
              background-color: #0a2dda;
              background-image: url(../assets/download-bold-white.png);
            }
            &:hover{
              background-color: #0a2dda;
            }
          }
        }
      }
    }
    &.video{
      .mediaWrapper{
        position: relative;
        .mediaCnt{
          display: block;
          .videoCover{
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            z-index: 9;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            width: auto; height: auto;
            border-radius: 5px;
            background-color: #333;
            overflow: hidden;
            cursor: pointer;
            &:before{
              content: "";
              position: absolute;
              width: 76px; height: 76px;
              border: #fff 4px solid;
              border-radius: 50%;
              left: 50%; top: 50%;
              transform: translate(-50%, -50%);
              background-image: url(../assets/play-icon-white.png);
              background-size: 34px auto;
              background-repeat: no-repeat;
              background-position: 25px 50%;
              z-index: 3;
              transition: all .3s ease;
              opacity: .74;
              @media (max-width: 960px) {
                width: 54px; height: 54px;
                border-width: 3px;
                background-size: 24px auto;
                background-position: 18px 50%;
              }
            }
            &:after{
              content: "";
              position: absolute;
              left: 0; right: 0; top: 0; bottom: 0;
              background-color: rgba(0, 0, 0, .24);
              z-index: 1;
              opacity: 0;
              transition: all .3s ease;
            }
            &:hover{
              &:before, &:after{
                opacity: 1;
              }
            }
            &.full{
              background-size: contain;
            }
          }
          .mediaContent{
            width: 100%;
            border-radius: 5px;
            overflow: hidden;
            iframe{
              width: 100%;
              height: 496px;
              display: block;
            }
          }
          .mediaInfo{
            width: auto;
            padding: 20px 10px 0;
          }
        }
      }
      &.protected{
        .mediaWrapper{
          .mediaCnt{
            .videoWrapper{
              height: 496px;
              border-radius: 5px;
              overflow: hidden;
              background-color: #aaa;
              .protectedContent{
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 0; right: 0; top: 0; bottom: 0;
                z-index: 9;
                &:before{
                  content: "";
                  position: absolute;
                  left: 0; right: 0; top: 0; bottom: 0;
                  background-color: #000;
                  opacity: .18;
                }
                .protectedContentIn{
                  position: relative;
                  z-index: 3;
                  img{
                    width: 54px;
                  }
                  h4{
                    margin: 0;
                    font-weight: 400;
                    font-size: 18px;
                  }
                }
              }
              .videoCover{
                cursor: default;
              }
              .videoCover:before, .videoCover:after{
                display: none;
              }
              .mediaContent{
                display: none;
              }
            }
          }
        }
      }
    }
    &.gallery{
      .mediaCnt{
        display: block;
        padding: 0;
        border: none;
      }
      .mediaGallery{
        height: 640px;
        position: relative;
        background-color: #222;
        min-height: calc(80vh);
        border-radius: 0.25rem;
        @media (max-width: 760px) {
          height: 520px;
        }
        @media (max-width: 680px) {
          height: 360px;
          min-height: 0;
        }
        .theImg{
          position: absolute;
          left: 40px; top: 40px; right: 40px; bottom: 80px;
          background-position: center;
          background-size: contain;
          background-repeat: no-repeat;
          cursor: pointer;
        }
        .downloadCnt{
          position: absolute;
          left: 0; right: 0; bottom: 10px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 4;
          .btn{
            border: none;
            background-color: transparent;
            color: #fff;
            height: 40px;
            transition: all .3s ease;
            border-radius: 50px;
            margin: 0 4px;
            display: inline-block;
            font-weight: normal;
            font-size: 15px;
            outline: 0;
            &:hover{
              background-color: #222;
            }
            &.download{
              padding: 0 20px;
              line-height: 40px;
              padding-left: 54px;
              position: relative;
              background-color: #333;
              &:hover{
                background-color: #222;
              }
              &:before{
                content: "";
                position: absolute;
                left: 20px; top: 7px;
                width: 20px; height: 20px;
                background-size: 20px auto;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url(../assets/download-white.png);
              }
            }
            &.openSlide{
              width: 40px;
              background-size: 28px auto;
              background-position: center;
              background-repeat: no-repeat;
              background-image: url(../assets/maximize-white.png);
            }
          }
        }
        .galleryNav{
          position: absolute;
          top: 50%;
          width: 30px; height: 30px;
          background-color: #fff;
          background-size: 12px auto;
          background-position: center;
          background-repeat: no-repeat;
          margin-top: -15px;
          border-radius: 50%;
          opacity: .65;
          cursor: pointer;
          transition: all .3s ease;
          z-index: 3;
          &:hover{
            opacity: 1;
          }
          &.p{
            left: 30px;
            background-image: url(../assets/left-arrow.png);
            @media (max-width: 680px) {
              left: 15px;
            }
          }
          &.n{
            right: 30px;
            background-image: url(../assets/right-arrow.png);
            @media (max-width: 680px) {
              right: 15px;
            }
          }
        }
        .galleryPager{
          position: absolute;
          bottom: 60px;
          display: flex;
          left: 0; right: 0;
          justify-content: center;
          .pagerItem{
            width: 8px; height: 8px;
            background-color: #ccc;
            border-radius: 50%;
            margin: 0 2px;
            cursor: pointer;
            &.active{
              background-color: #0057d8;
            }
          }
        }
      }
      .mediaInfo{
        width: auto;
        padding: 20px 30px;
      }
      &.protected{
        .mediaWrapper{
          .mediaCnt{
            overflow: hidden;
            .videoWrapper{
              height: 496px;
              overflow: hidden;
              background-color: #aaa;
              .protectedContent{
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 0; right: 0; top: 0; bottom: 0;
                z-index: 9;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                &:before{
                  content: "";
                  position: absolute;
                  left: 0; right: 0; top: 0; bottom: 0;
                  background-color: #000;
                  opacity: .18;
                }
                .protectedContentIn{
                  position: relative;
                  z-index: 3;
                  img{
                    width: 54px;
                  }
                  h4{
                    margin: 0;
                    font-weight: 400;
                    font-size: 18px;
                  }
                }
              }
              .videoCover{
                cursor: default;
              }
              .videoCover:before, .videoCover:after{
                display: none;
              }
              .mediaContent{
                display: none;
              }
            }
          }
        }
      }
    }
    &.audio{
      .mediaWrapper{
        position: relative;
        .mediaCnt{
          display: block;
          .videoCover{
            z-index: 9;
            height: 340px;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
            border-radius: 5px;
            background-color: #d9d6e4;
            overflow: hidden;
            cursor: pointer;
            &.full{
              background-size: contain;
            }
          }
          .mediaContent{
            width: 100%;
            border-radius: 5px;
            overflow: hidden;
          }
        }
      }
      .mediaInfo{
        width: auto;
        padding: 10px 10px 0;
      }
      &.protected{
        .mediaWrapper{
          .mediaCnt{
            .videoWrapper{
              position: relative;
              overflow: hidden;
              border-radius: 5px;
              background-color: #aaa;
              .protectedContent{
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 0; right: 0; top: 0; bottom: 0;
                z-index: 9;
                &:before{
                  content: "";
                  position: absolute;
                  left: 0; right: 0; top: 0; bottom: 0;
                  background-color: #000;
                  opacity: .18;
                }
                .protectedContentIn{
                  position: relative;
                  z-index: 3;
                  img{
                    width: 54px;
                  }
                  h4{
                    margin: 0;
                    font-weight: 400;
                    font-size: 18px;
                  }
                }
              }
              .videoCover{
                cursor: default;
              }
              .videoCover:before, .videoCover:after{
                display: none;
              }
              .mediaContent{
                display: none;
              }
            }
          }
        }
      }
    }
    &.pdf, &.file{
      .mediaWrapper{
        .mediaCnt{
          .mediaImg{
            border-radius: 5px;
            overflow: hidden;
            img{
              display: block;
            }
          }
        }
      }
      &.protected{
        .mediaWrapper{
          .mediaCnt{
            align-items: flex-start;
            .mediaImg.noImg{
              background-image: none !important;
            }
            .videoWrapper{
              border-radius: 5px;
              overflow: hidden;
              background-color: #aaa;
              .protectedContent{
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                left: 0; right: 0; top: 0; bottom: 0;
                z-index: 9;
                padding: 0;
                &:before{
                  content: "";
                  position: absolute;
                  left: 0; right: 0; top: 0; bottom: 0;
                  background-color: #000;
                  opacity: .18;
                }
                .protectedContentIn{
                  position: relative;
                  z-index: 3;
                  img{
                    width: 46px;
                  }
                  h4{
                    margin: 0;
                    font-weight: 400;
                    font-size: 15px !important;
                  }
                }
              }
            }
          }
        }
      }
    }
    .articleShare.articleShareBottom{
      padding-top: 20px;
      @media (max-width: 640px) {
        padding-left: 20px;
      }
    }
  }
  &.profile{
    padding: 20px 0 60px;
    margin: 0 auto;
    .profileCnt{
      position: relative;
      display: flex;
      flex-wrap: wrap;
      @media (max-width: 768px) {
        display: block;
      }
      .profileMetadata{
        display: flex;
        flex-wrap: wrap;
        padding: 20px 0 0;
        @media (max-width: 768px) {
          justify-content: center;
        }
        .metadataItem{
          width: 34px; height: 34px;
          margin: 0 6px 6px 0;
          border-radius: 50%;
          background-color: #e9e9e9;
          cursor: pointer;
          transition: all .3s ease;
          position: relative;
          &:before{
            content: "";
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            background-position: center;
            background-size: 20px auto;
            background-repeat: no-repeat;
            opacity: .76;
            transition: all .3s ease;
          }
          &.googleScholar:before{
            background-image: url(../assets/graduation-black.png);
            background-size: 22px auto;
          }
          &.facebook:before{
            background-image: url(../assets/facebook-black.png);
            background-size: 18px auto;
          }
          &.twitter:before{
            background-image: url(../assets/twitter-black.png);
          }
          &.linkedIn:before{
            background-image: url(../assets/linkedin-black.png);
            background-size: 18px auto;
          }
          &.youtube:before{
            background-image: url(../assets/youtube-black.png);
          }
          &.tiktok:before{
            background-image: url(../assets/tiktok-black.png);
          }
          &.spotify:before{
            background-image: url(../assets/spotify-black.png);
          }
          &.instagram:before{
            background-image: url(../assets/instagram-black.png);
            background-size: 18px auto;
          }
          &.email:before{
            background-image: url(../assets/email.png);
            background-size: 17px auto;
          }
          &.web:before{
            background-image: url(../assets/web.png);
          }
          &:hover{
            background-color: #008552;
            &:before{
              filter: invert(1);
              opacity: 1;
            }
          }
        }
      }
      .profileImgCnt{
        width: 400px;
        @media (max-width: 1480px) {
          width: 360px;
        }
        @media (max-width: 1240px) {
          width: 300px;
        }
        @media (max-width: 940px) {
          width: 260px;
        }
        @media (max-width: 768px) {
          width: auto;
          max-width: 300px;
          margin: 0 auto 30px;
        }
        @media (max-width: 480px) {
          max-width: none;
        }
      }
      .profileImg{
        width: 400px; height: 400px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 5px;
        @media (max-width: 1480px) {
          width: 360px; height: 360px;
        }
        @media (max-width: 1240px) {
          width: 300px; height: 300px;
        }
        @media (max-width: 940px) {
          width: 260px; height: 260px;
        }
        @media (max-width: 768px) {
          width: auto;
          max-width: 300px;
          height: 300px;
          margin: 0 auto 30px;
        }
        @media (max-width: 480px) {
          max-width: none;
        }
        &.full{
          background-color: #ddd;
          background-size: contain;
          // background-image: none !important;
          // height: auto;
          // overflow: hidden;
          img{
            width: 100%;
            // display: block;
            display: none;
          }
        }
        &.noImg{
          background-image: url(../assets/image-black.png);
          background-size: 64px auto;
          opacity: .36;
          background-color: #eee;
        }
        &.protected{
          position: relative;
          overflow: hidden;
          .protectedContent{
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            left: 0; right: 0; top: 0; bottom: 0;
            &:before{
              content: "";
              position: absolute;
              left: 0; right: 0; top: 0; bottom: 0;
              background-color: #000;
              opacity: .18;
            }
            .protectedContentIn{
              position: relative;
              z-index: 3;
              img{
                width: 52px;
              }
              h4{
                margin: 0;
                font-weight: 400;
                font-size: 17px;
              }
            }
          }
        }
      }
      .profileInfo{
        padding: 10px 0 10px 60px;
        box-sizing: border-box;
        width: calc(100% - 400px);
        @media (max-width: 1480px) {
          width: calc(100% - 360px);
        }
        @media (max-width: 1240px) {
          width: calc(100% - 300px);
          padding-left: 40px;
        }
        @media (max-width: 940px) {
          width: calc(100% - 260px);
        }
        @media (max-width: 768px) {
          width: auto;
          padding: 0;
        }
        .articleDetail{
          border-top: #ccc 1px solid;
          padding-top: 20px;
          .content{
            margin: 0;
            max-width: none;
          }
        }
        h4{
          margin: 0 0 16px;
          font-size: 30px;
          line-height: 1.3;
          @media (max-width: 960px) {
            font-size: 26px;
          }
          @media (max-width: 860px) {
            font-size: 22px;
          }
          @media (max-width: 640px) {
            font-size: 20px;
          }
        }
        .position{
          color: #767676;
          margin: -10px 0 16px;
        }
        .infoItem{
          display: flex;
          padding: 0 0 10px;
          font-size: 17px;
          @media (max-width: 960px) {
            font-size: 16px;
          }
          @media (max-width: 640px) {
            display: block;
            padding: 0 0 14px;
          }
          .infoLabel{
            font-weight: 500;
            color: #008552;
            width: 150px;
            box-sizing: border-box;
            @media (max-width: 640px) {
              width: auto;
            }
          }
          .infoValue{
            width: calc(100% - 150px);
            box-sizing: border-box;
            @media (max-width: 640px) {
              width: auto;
            }
          }
        }
      }
    }
  }
}

.notFoundCnt{
  position: relative;
  height: calc(100vh - 86px);
  @media (max-width: 1480px) {
    height: calc(100vh - 64px);
  }
  @media (max-width: 768px) {
    height: calc(100vh - 56px);
  }
  .notFound{
    position: absolute;
    left: 40px; right: 40px;
    top: 50%; transform: translateY(-50%);
    text-align: center;
    color: #767676;
    img{
      height: auto;
      width: 100%;
      max-width: 360px;
      margin: 0 auto 40px;
    }
    h2{
      margin: 10px 0;
      font-size: 26px;
      line-height: 1;
    }
    h4{
      margin: 0 0 10px;
      font-size: 40px;
      line-height: 1;
    }
    button{
      margin-top: 20px;
      border: #ccc 1px solid;
      border-radius: 5px;
      padding: 8px 16px;
      transition: all .3s ease;
      &:hover{
        box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
      }
    }
    p{
      margin: 0;
    }
  }
}

.sectionCnt.article{
  margin-top: -60px;
}
</style>
